import React from 'react';
import HeroSection from './components/HeroSection';
import WhatYouWillLearn from './components/WhatYouWillLearn';
import Testimonials from './components/Testimonials';
import DiscountForm from './components/DiscountForm';
import target_audience_photo_1 from './img/forwhom_1.png';
import target_audience_photo_2 from './img/forwhom_2.png';
import target_audience_photo_3 from './img/forwhom_3.png';
import checkIcon from "./img/list.svg";
import learning from "./img/learning.png"; 
import result from "./img/result.png";
import TargetIcon from "./img/target.png";
import mentorPhoto from "./img/photo.png";
import quoteIcon from "./img/quote.svg";
import './App.css';

function App() {

  const text = "Стоимость 250 000 тенге / ";

  
  return (
    <div className="landing-container">

      {/* Шапка сайта (Header) */}
      <HeroSection/>
      <header className="header">
        <div className="header-content">
          <h1>
            Наргыз Аманбекова – ведущий эксперт в области маркетинговых инноваций и персонализированной рекламы
          </h1>
          <p className="header-subtitle">
            Узнайте, как вывести рекламу на принципиально новый уровень, используя технологии Big Data и AI-аналитики.
          </p>
          <a className="header-button" href="#methodology">
            Подробнее о курсе
          </a>
        </div>
      </header>

      {/* Основной блок: информация о Наргыз */}
      <section id="about-nargiz" className="content-section">
        <h2 className="section-title">О Наргыз Аманбековой</h2>
        <ul className='content-list'>
          <li>Один из самых уважаемых и влиятельных специалистов в сфере цифрового маркетинга и рекламных технологий в СНГ. С 2017 года она занимала позицию Директора по маркетинговым коммуникациям в крупнейшем сетевом рекламном агентстве Казахстана GForce Grey и внесла значительный вклад в его международное развитие. Под ее руководством агентство вышло на международный уровень.</li>
          <p className='content-list-text'>Среди реализованных под её руководством проектов — «Kaspi Evolution» (2017) и «Magnum Next» (2018), которые стали поворотными точками как для самих брендов, так и для агентства:</p>
          <p className='content-list-text'>В проекте Kaspi.kz Наргыз возглавляла стратегическую трансформацию бренда, включая разработку новой коммуникационной платформы, перестройку клиентского пути, интеграцию digital-инструментов и запуск первой в истории Kaspi.kz digital-кампании. В результате — рост новых пользователей на 47%, рост индекса NPS на 38% и вхождение Kaspi.kz в топ-10 брендов страны по версии Forbes Kazakhstan.</p>
          <p className='content-list-text'>В проекте Magnum Cash&Carry она разработала и реализовала масштабную омниканальную стратегию «Magnum Next», включая запуск e-commerce, мобильного приложения, персонализированной системы коммуникаций и продвижения программы лояльности. Проект обеспечил рост онлайн-продаж на 89%, более 1 млн установок приложения и получил серебро на Red Jolbors 2019.</p>
          <p className='content-list-text'>Подход Наргыз сочетает высокую управленческую автономию, стратегическое мышление и внедрение инноваций на всех этапах. Это делает её одной из центральных фигур в индустрии маркетинговых коммуникаций на пространстве СНГ.</p>
          <li>В 2018 году Ныргыз Аманбекова разработала революционную Методологию «Настройка рекламы по психотипу пользователей на основе контента соцсетей», которая уже много лет используется крупнейшими маркетинговыми агентствами и брендами. Эта технология позволяет анализировать лайки, комментарии, посты пользователей, чтобы определять их эмоциональный фон, мотивацию и ключевые триггеры, на которые они откликаются. В результате реклама становится не только персонализированной, но и максимально релевантной, что увеличивает уровень вовлеченности на 40%, а конверсии – в среднем на 35%. Сегодня данную методику применяют ведущие маркетологи России, Казахстана, Украины и Беларуси, а мировые компании активно тестируют ее для своих рекламных стратегий.</li>
          <li>Наргыз – признанный лидер мнений и авторитетный спикер, активно выступающий на крупнейших маркетинговых форумах и конференциях по всему миру. Она была ключевым спикером на таких международных конференциях как Международный бизнес форум "Инновации в маркетинге", Международной конференции «Marketing 360: Trends & Insights», где делилась с маркетологами своей уникальной методологией "Настройка рекламы по психотипу пользователей на основе контента соцсетей"</li>
          <li>Помимо практической деятельности, Наргыз активно занимается исследованиями в области AI-маркетинга и digital-стратегий, публикуя научные статьи в ведущих маркетинговых изданиях. Ее работы включают такие темы, как "CRM-системы как инструмент повышения эффективности маркетинга" (2018), "Influencer-маркетинг: роль лидеров мнений в формировании потребительских предпочтений" (2020), "Искусственный интеллект в цифровом маркетинге: новые стратегии и тенденции" (2023). Эти публикации стали настольными пособиями для профессионалов, работающих в сфере digital-маркетинга, поскольку в них представлены уникальные модели прогнозирования поведения пользователей, применения AI-алгоритмов и оптимизации рекламных бюджетов.</li>
          <li>В 2020 году, в разгар пандемии COVID-19, она адаптировала свою методологию к изменившимся реалиям и представила новые стратегии в Influencer-маркетинге и AI-персонализации, что позволило брендам не только сохранить, но и увеличить свою долю рынка в условиях кризиса.</li>
        
          <li>Благодаря новаторским подходам и стратегическому видению, Наргыз Аманбекова по праву входит в число самых влиятельных маркетологов СНГ. Ее достижения подтверждаются сотнями успешных рекламных кейсов, международными наградами и признанием в профессиональном сообществе. Она не только формирует будущее маркетинговой индустрии, но и задает глобальные тренды в области AI-аналитики и персонализированного контента, помогая брендам выстраивать глубокие и осмысленные коммуникации с аудиторией. В ближайшие годы ее технологии и идеи продолжат трансформировать индустрию, делая рекламу не только более эффективной, но и максимально ориентированной на реальные потребности людей.</li>
        </ul>


      </section>

      <section className="target-audience">
      <h2 className="target-audience__title">Для кого курс</h2>

      <div className="target-audience__cards">
        {/* Карточка 1: Для вас */}
        <div className="target-audience__card">
          <div className="card-image card-image--for-you">
            {/* Здесь можно вставить ваш img */}
            <img
              src={target_audience_photo_1}
              alt="Улыбающаяся девушка с планшетом"
              className="card-image__img"
            />
          </div>
          <h3 className="card-title">Для вас</h3>
          <p className="card-text">
            Улучшите знания в маркетинге и научитесь работать в команде, чтобы
            продвинуться по карьерной лестнице
          </p>
        </div>

        {/* Карточка 2: Предпринимателям */}
        <div className="target-audience__card">
          <div className="card-image card-image--entrepreneurs">
            <img
              src={target_audience_photo_2}
              alt="Мужчина в костюме"
              className="card-image__img"
            />
          </div>
          <h3 className="card-title">Предпринимателям</h3>
          <p className="card-text">
            Станьте профессионалом в диджитал-маркетинге, чтобы вывести свою
            компанию на новый уровень
          </p>
        </div>

        {/* Карточка 3: Руководителям и директорам */}
        <div className="target-audience__card">
          <div className="card-image card-image--directors">
            <img
              src={target_audience_photo_3}
              alt="Женщина с планшетом"
              className="card-image__img"
            />
          </div>
          <h3 className="card-title">Руководителям и директорам</h3>
          <p className="card-text">
            Систематизируйте знания, постройте диджитал-стратегию и освоите
            новые инструменты для эффективного продвижения
          </p>
        </div>
      </div>
    </section>

      <WhatYouWillLearn/>
  

    <div className="marquee-container">
      <div className="marquee-content">
        {/* Дублируем текст дважды для бесшовного эффекта */}
        <p className="marquee-text">{text.repeat(20)}</p>
        <p className="marquee-text">{text.repeat(20)}</p>
      </div>
    </div>


    <section className="learning-process">
    <div className="learning-cont">
      <div className="text-content">
        <h2>Как проходит обучение</h2>
        <ul>
          <li>
            <img src={checkIcon} alt="✔" /> Смотрите лекции и кейсы в удобном для вас темпе
          </li>
          <li>
            <img src={checkIcon} alt="✔" /> Выполняете практические задания на отработку новых навыков
          </li>
          <li>
            <img src={checkIcon} alt="✔" /> Если возникают вопросы, отправляете их куратору
          </li>
          <li>
            <img src={checkIcon} alt="✔" /> Защищаете дипломную работу и получаете официальный документ
          </li>
        </ul>
      </div>
      <div className="image-container">
        <img src={learning} alt="Обучение" className="right-image" />
      </div>
      </div>
    </section>

    <section className="course-result">
    <div className="course-result-cont">
      <div className="content">
        <h3>Результат курса</h3>
        <p>
          В результате обучения у вас будет готовая маркетинговая стратегия для выбранного вами проекта
        </p>
        <div className="price">
          <span>Стоимость курса</span>
          <span className="price-tag"> 250 000 ₸</span>
        </div>
      </div>
      <div className="image-container">
        <img src={result} alt="Результаты курса" className="result-image" />
      </div>
      </div>
    </section>

    <section className="mentor-section">
      <div className="content">
        <h1>Получай образование от лучших</h1>

        <div className="quote-box">
        <img src={quoteIcon} alt="Кавычки" className="quote-icon" />
          <p>
            <strong>Инвестирую в учеников десятки часов личного времени:</strong>
            <br />
            разборы, мастер-классы, эфиры, марафоны внутри курса. Мною движет желание
            перевернуть рынок онлайн-образования и зарекомендовать свой курс, как один из лучших.
          </p>
        </div>
      </div>

      <div className="mentor-photo-container">
        <img src={mentorPhoto} alt="Наргыз Аманбекова" className="mentor-photo" />

        <div className="card card-left">
          <p><strong>4500+ учеников</strong></p>
          <span>более 400 крупных маркетинговых агентств купили этот курс для своих сотрудников</span>
        </div>

        <div className="card card-right">
          <p><strong>Заработала более 1 млн $ от продажи курса</strong></p>
          <span>Вошла в ТОП 5 самых продаваемых курсов по маркетингу в СНГ</span>
        </div>

        <div className="mentor-info">
          <h3>Наргыз Аманбекова</h3>
          <span className="author-role">Автор курса</span>
        </div>
      </div>
    </section>

    <section className="how-it-works">
      <h2 className="section-title">Как это работает?</h2>

      <div className="step">
        <h3>1. Глубокий анализ поведения пользователя</h3>
        <p>Мы используем Big Data и AI, чтобы понять, что действительно важно для вашей аудитории:</p>
        <ul className="content-list">
          <li>Посты, комментарии, лайки, реакции и частота активности</li>
          <li>Тональность сообщений (позитивная, нейтральная, негативная)</li>
          <li>Интересы и подписки на бренды, инфлюенсеров, группы</li>
        </ul>
        <p className="highlight">
          <img src={TargetIcon} alt="Цель" className="icon" /> Результат: Наш алгоритм строит персонализированный
          психологический профиль каждого пользователя и определяет, какие рекламные сообщения сработают лучше всего.
        </p>
      </div>

      <div className="step">
        <h3>2. Определение психотипа и поведенческих триггеров</h3>
        <p>На основе данных ИИ определяет, кто ваш клиент:</p>
        <ul className="content-list">
          <li>Логик → Ему нужны факты и рациональные доводы</li>
          <li>Эстет → Важен визуальный стиль, креатив и эмоции</li>
          <li>Импульсивный покупатель → Любит скидки, акции, срочные предложения</li>
          <li>Искатель новинок → Всегда в поиске свежих трендов</li>
        </ul>
        <p className="highlight">
          <img src={TargetIcon} alt="Цель" className="icon" /> Результат: Вы получаете персонализированную стратегию взаимодействия с каждым сегментом аудитории.
        </p>
      </div>

      <div className="step">
        <h3>3. Автоматическая настройка рекламы</h3>
        <ul className="content-list">
          <li>Определение лучших каналов коммуникации (Instagram, Facebook, TikTok, YouTube)</li>
          <li>Создание динамического рекламного контента под каждого пользователя</li>
          <li>Оптимизация таргетинга, бюджета и ставок в реальном времени</li>
        </ul>
        <p className="highlight">
          <img src={TargetIcon} alt="Цель" className="icon" /> Результат: Повышенная вовлеченность, снижение стоимости клика (CPC) и рост конверсии!
        </p>
      </div>
    </section>





    <section className="company-stats">
      <div className="stats-container">
        <div className="stat">
          <h2>+40% <br/> рост вовлеченности</h2>
          <p>Ваши объявления больше не игнорируют!
          </p>
        </div>
        <div className="stat">
          <h2>+35% <br/> повышение конверсии</h2>
          <p>Объявления максимально адаптированы под пользователя</p>
        </div>
        <div className="stat">
          <h2>-25% <br/> снижение рекламных затрат</h2>
          <p>Платите только за реальный отклик аудитории</p>
        </div>
      </div>
      <div className="revenue">
        <h3>Возможный годовой доход</h3>
        <h1>> 1 000 000 ₸</h1>
      </div>
    </section>



    <Testimonials/>








      <DiscountForm />

      {/* Подвал сайта */}
      <footer className="footer">
        <p>© 2018 Все права защищены. Наргыз Аманбекова.</p>
      </footer>
    </div>
  );
}

export default App;
